import React from 'react';
import { Search, Settings, Briefcase } from 'lucide-react';
interface TopBarProps {
  onOpenAdmin: () => void;
}
export function TopBar({
  onOpenAdmin
}: TopBarProps) {
  return <header className="h-14 border-b border-slate-200 bg-white flex items-center justify-between px-6 shrink-0 z-10" data-id="element-265">
      <div className="flex items-center gap-3 text-slate-900 font-semibold" data-id="element-266">
        <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center text-white shadow-sm" data-id="element-267">
          <Briefcase size={18} data-id="element-268" />
        </div>
        <span className="text-lg tracking-tight" data-id="element-269">Claim Workspace</span>
      </div>

      <div className="flex items-center gap-6" data-id="element-270">
        <div className="relative group w-72" data-id="element-271">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-blue-500 transition-colors" size={16} data-id="element-272" />
          <input type="text" placeholder="Search loans or borrowers..." className="h-9 w-full pl-9 pr-4 rounded-full bg-slate-100 border-transparent focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 text-sm transition-all outline-none" data-id="element-273" />
        </div>

        <div className="flex items-center gap-3 border-l border-slate-200 pl-6" data-id="element-274">
          <button onClick={onOpenAdmin} className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-slate-600 hover:text-blue-700 hover:bg-blue-50 rounded-full transition-colors group" title="Admin Settings & Analytics" data-id="element-275">
            <Settings size={16} className="group-hover:rotate-45 transition-transform duration-300" data-id="element-276" />
            <span data-id="element-277">Admin</span>
          </button>
          <div className="w-8 h-8 rounded-full bg-gradient-to-tr from-slate-700 to-slate-900 text-white text-xs font-medium flex items-center justify-center border-2 border-white shadow-sm" data-id="element-278">
            JS
          </div>
        </div>
      </div>
    </header>;
}